"use client";

import { c as _c } from "react/compiler-runtime";
import { useId, useState } from "react";
import { trackAction } from "@local/tracking/src/trackActions";
import { hexToRgb } from "@local/utils/src/hexToRgb";
import { Transition } from "../../../Transition";
import { ArrowDownIcon } from "../../ui/icons";
import type { FaqItemData } from "./types";
interface FaqItemProps {
  itemData: FaqItemData & {
    link?: string;
  };
  textColor?: string;
  index?: number;
}
export const FaqItem = t0 => {
  const $ = _c(38);
  const {
    itemData,
    index,
    textColor
  } = t0;
  const [isOpen, setIsOpen] = useState(index === 0);
  const reactId = useId();
  const panelId = `faq-panel-${reactId}`;
  let t1;
  if ($[0] !== textColor) {
    t1 = textColor ? hexToRgb(`${textColor}80`) : undefined;
    $[0] = textColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      borderColor: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== index || $[5] !== isOpen || $[6] !== itemData.question) {
    t3 = () => {
      const next = !isOpen;
      setIsOpen(next);
      trackAction(next ? "faq_opened" : "faq_closed", {
        question: itemData.question,
        index
      });
    };
    $[4] = index;
    $[5] = isOpen;
    $[6] = itemData.question;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isOpen) {
    t4 = isOpen ? {
      transform: "rotate(180deg)"
    } : undefined;
    $[8] = isOpen;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ArrowDownIcon />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4) {
    t6 = <span aria-hidden="true" className="inline-block transition-transform duration-100 motion-reduce:transition-none" style={t4}>{t5}</span>;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isOpen || $[14] !== itemData.question || $[15] !== panelId || $[16] !== t3 || $[17] !== t6) {
    t7 = <button type="button" className="flex w-full flex-row items-center justify-between text-left text-lg font-bold focus-visible:ring-2 focus-visible:ring-gray-400 focus-visible:ring-offset-2" aria-expanded={isOpen} aria-controls={panelId} onClick={t3}>{itemData.question}{t6}</button>;
    $[13] = isOpen;
    $[14] = itemData.question;
    $[15] = panelId;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t2 || $[20] !== t7) {
    t8 = <dt className="mb-2 cursor-pointer text-base leading-6 font-medium md:text-lg" style={t2}>{t7}</dt>;
    $[19] = t2;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== textColor) {
    t9 = textColor ? hexToRgb(`${textColor}80`) : undefined;
    $[22] = textColor;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t9) {
    t10 = {
      borderColor: t9
    };
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const t11 = itemData.link ? `<a href="${itemData.link}" style="text-decoration: underline; color: indigo">${itemData.answer}</a>` : itemData.answer;
  let t12;
  if ($[26] !== t11) {
    t12 = <div className="mt-4 text-left text-base" dangerouslySetInnerHTML={{
      __html: t11
    }} />;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== isOpen || $[29] !== t12) {
    t13 = <Transition show={isOpen} enter="transition ease-out duration-100" enterFrom="scale-95 transform opacity-0" enterTo="scale-100 transform opacity-100" leave="transition ease-out duration-100" leaveFrom="scale-100 transform opacity-100" leaveTo="scale-95 transform opacity-0">{t12}</Transition>;
    $[28] = isOpen;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== panelId || $[32] !== t10 || $[33] !== t13) {
    t14 = <dd id={panelId} className="mb-8 border-b pb-2" style={t10}>{t13}</dd>;
    $[31] = panelId;
    $[32] = t10;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t14 || $[36] !== t8) {
    t15 = <>{t8}{t14}</>;
    $[35] = t14;
    $[36] = t8;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  return t15;
};